<template>
  <router-view />
  <Loading v-model:active="load" :can-cancel="false" :is-full-page=true />
  <h2 v-if="serve == 'https://dev.napoleon-chat.com/api/'" style="color: white;">Despliegue en Dev</h2>
  <h2 v-if="serve == 'https://staging.napoleon-chat.com/api/'" style="color: white;">Despliegue en QA</h2>
  <h2 v-if="serve == 'http://127.0.0.1:8000/api/'" style="color: white;">Despliegue en Local</h2>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex';
import { getEnv } from './config/config';

export default {
  computed: mapState(['load']),
  data() {
    return {
      isLoading: false,
      serve: '',
    }
  },
  mounted() {
    this.serve = getEnv("VUE_APP_SERVER_URL") ?? ""
  },
  watch: {
    load(state) {
      if (state === true) {
        this.isLoading = true
      }
      if (state === false) {
        this.isLoading = false
      }
    }
  },
  components: {
    Loading
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

body {
  background-image: url('assets/fondo-celular.png');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
</style>
